import React from 'react';

import { Segmented } from 'antd';

import styled from 'styled-components';

import CustomSwitch from '@components/Gui/CustomSwitch';
import TagFilterPicker from '@components/TagPicker/TagFilterPicker';

import ModelDetailsBooksCharacteristicsFilter from './ModelDetailsBooksCharacteristicsFilter';
import { BOOKS_SORT_OPTIONS } from './modelDetailsBooks.utils';

/* I tre gruppi uno sotto l'altro quando manca larghezza al viewport. */
const stackedFilters = `
    grid-template-columns: 1fr;

    .filter-left {
        flex-wrap: wrap;
    }

    .filter-center,
    .filter-right {
        justify-self: start;
    }
`;

/* In un contenitore stretto la media query non aiuta: guarda il viewport, non il
   contenitore. Qui i gruppi vanno a capo solo quando serve e la fascia sparisce:
   la separazione dalle altre sezioni la dà il contenitore. */
const compactFilters = `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    border-top: none;
    border-bottom: none;

    .filter-left {
        flex-wrap: wrap;
    }
`;

const BookFiltersWrapper = styled.div`
    padding: ${(props) => (props.$compact ? '0' : '0.75rem 4rem')};
    background-color: ${(props) => props.theme.LayoutBodyBackground};
    border-top: 1px solid ${(props) => props.theme.BorderColor};
    border-bottom: 1px solid ${(props) => props.theme.BorderColor};
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
    gap: ${(props) => (props.$compact ? '0.75rem 1.25rem' : '2rem')};

    .filter-left {
        display: flex;
        align-items: center;
        gap: ${(props) => (props.$compact ? '1.25rem' : '2rem')};
        min-width: 0;
    }

    .filter-center {
        justify-self: center;
    }

    .filter-right {
        justify-self: end;
    }

    ${(props) => props.$compact && compactFilters}

    @media only screen and (max-width: 1160px) {
        ${(props) => !props.$compact && stackedFilters}
    }
`;

const ModelDetailsBooksDrawerFilters = ({
    booksSort,
    compact = false,
    filterTags,
    onBooksSortChange,
    onPlaylistCharacteristicFilterChange,
    onFilterTagsChange,
    onOnlyMineChange,
    onTagFilterModeChange,
    onlyMine,
    playlistCharacteristicFilter,
    tagFilterMode,
    showOnlyMine = true,
    showTags = true,
}) => {
    return (
        <BookFiltersWrapper $compact={compact}>
            {(showTags || showOnlyMine) && (
                <div className="filter-left">
                    {showTags && (
                        <div className="filter-item">
                            <TagFilterPicker
                                itemType="Playlist"
                                selectedOptions={filterTags}
                                filterMode={tagFilterMode}
                                onChange={onFilterTagsChange}
                                onFilterModeChange={onTagFilterModeChange}
                            />
                        </div>
                    )}
                    {showOnlyMine && (
                        <div className="filter-item">
                            <CustomSwitch checked={onlyMine} onChange={onOnlyMineChange} text="only mine" />
                        </div>
                    )}
                </div>
            )}
            <div className="filter-center">
                <ModelDetailsBooksCharacteristicsFilter
                    value={playlistCharacteristicFilter}
                    onChange={onPlaylistCharacteristicFilterChange}
                />
            </div>
            <div className="filter-right">
                <Segmented options={BOOKS_SORT_OPTIONS} onChange={onBooksSortChange} value={booksSort} />
            </div>
        </BookFiltersWrapper>
    );
};

export default ModelDetailsBooksDrawerFilters;
